import React from 'react';
import iconify from '../iconify';

const SvgStar = props => (
  <svg width={20.788} height={27.527} {...props}>
    <defs>
      <linearGradient
        id="star_svg__a"
        x1={0.5}
        x2={0.5}
        y2={1}
        gradientUnits="objectBoundingBox"
      >
        <stop offset={0} stopColor="#d3793b" />
        <stop offset={1} stopColor="#e64a50" />
      </linearGradient>
    </defs>
    <g data-name="Group 893">
      <g data-name="Group 878">
        <path
          data-name="Path 522"
          d="M-534.62-1503.373a.505.505 0 01-.243-.062l-5.668-3.095-5.485 3.092a.505.505 0 01-.54-.028.506.506 0 01-.207-.5l1.126-6.492-4.846-4.224a.506.506 0 01-.152-.528.5.5 0 01.418-.356l6.555-.866 2.667-5.819a.506.506 0 01.46-.3.505.505 0 01.46.3l2.667 5.819 6.585.867a.5.5 0 01.419.356.506.506 0 01-.154.528l-4.868 4.218 1.3 6.484a.507.507 0 01-.2.507.508.508 0 01-.294.099zm-5.914-4.242a.506.506 0 01.243.062l4.962 2.71-1.145-5.709a.506.506 0 01.165-.482l4.24-3.674-5.746-.756a.506.506 0 01-.394-.291l-2.324-5.07-2.323 5.07a.506.506 0 01-.394.291l-5.722.756 4.216 3.675a.5.5 0 01.166.468l-.993 5.721 4.8-2.706a.506.506 0 01.249-.065z"
          transform="translate(550.913 1530.641)"
          stroke="#e64a50"
          strokeWidth={0.5}
          fill="url(#star_svg__a)"
        />
      </g>
      <g data-name="Group 879">
        <path
          data-name="Path 523"
          d="M-550.15-1525.654a.506.506 0 01-.506-.506v-12.4a.506.506 0 01.506-.506.506.506 0 01.506.506v12.4a.506.506 0 01-.506.506z"
          transform="translate(550.913 1539.316)"
          stroke="#e64a50"
          strokeWidth={0.5}
          fill="url(#star_svg__a)"
        />
      </g>
      <g data-name="Group 880">
        <path
          data-name="Path 524"
          d="M-509.649-1525.654a.506.506 0 01-.506-.506v-12.4a.506.506 0 01.506-.506.506.506 0 01.506.506v12.4a.506.506 0 01-.506.506z"
          transform="translate(529.644 1539.316)"
          stroke="#e64a50"
          strokeWidth={0.5}
          fill="url(#star_svg__a)"
        />
      </g>
      <g data-name="Group 881">
        <path
          data-name="Path 525"
          d="M-540.025-1527.931a.506.506 0 01-.506-.506v-10.122a.506.506 0 01.506-.506.506.506 0 01.506.506v10.122a.506.506 0 01-.506.506z"
          transform="translate(545.596 1539.316)"
          stroke="#e64a50"
          strokeWidth={0.5}
          fill="url(#star_svg__a)"
        />
      </g>
      <g data-name="Group 882">
        <path
          data-name="Path 526"
          d="M-518.708-1527.931a.506.506 0 01-.506-.506v-10.122a.506.506 0 01.506-.506.506.506 0 01.506.506v10.122a.506.506 0 01-.506.506z"
          transform="translate(534.402 1539.316)"
          stroke="#e64a50"
          strokeWidth={0.5}
          fill="url(#star_svg__a)"
        />
      </g>
      <g data-name="Group 883">
        <path
          data-name="Path 527"
          d="M-529.9-1532.992a.506.506 0 01-.506-.506v-5.061a.506.506 0 01.506-.506.506.506 0 01.506.506v5.061a.506.506 0 01-.506.506z"
          transform="translate(540.279 1539.316)"
          stroke="#e64a50"
          strokeWidth={0.5}
          fill="url(#star_svg__a)"
        />
      </g>
    </g>
  </svg>
);

export default iconify(SvgStar);
